(function () {
  "use strict";

  TitleCtrl.$inject = ['$rootScope', '$routeParams', 'arrangeResource', 'courseTraineesResource', 'mtypes', 'authView'];
  angular
    .module('trainerWebApp.controllers')
    .controller('TitleCtrl', TitleCtrl);

  function TitleCtrl($rootScope, $routeParams, arrangeResource, courseTraineesResource, mtypes, authView) {
    var objectId = $routeParams.seriesId;
    if ($routeParams.seriesId) {
      if (!~mfConfig.features.indexOf(mtypes.featureEntry.series) && !authView.isActiveAdvancedtrial())
        $rootScope.title = {seriesTitle: "Sample Series"}; // for preview
      else
        $rootScope.title = arrangeResource.getCourseTitle(objectId, function (res) {
          if (_.isNull(res.title.seriesTitle) || _.isEmpty(res.title.seriesTitle)) {
            res.title.seriesTitle = "Untitled Series";
          }
          $rootScope.title = res.title;
        });
    } else if ($routeParams.courseId) {
      objectId = $routeParams.courseId;
      $rootScope.title = courseTraineesResource.getCourseTitle(objectId, function (res) {
        if (_.isNull(res.title.courseTitle) || _.isEmpty(res.title.courseTitle)) {
          res.title.courseTitle = "Untitled Course";
        }
        $rootScope.title = res.title;
      });
    }
  }

})();
